export const stripHTML = (htmlString: string | null | undefined): string => {
  const str = htmlString ?? '';
  const chars: string[] = [];
  let inTag = false;

  for (const char of str) {
    if (char === '<') {
      inTag = true;
    } else if (char === '>') {
      inTag = false;
    } else if (!inTag) {
      chars.push(char);
    }
  }

  return chars.join('');
};
